import React from 'react';
import { useQuery } from 'react-apollo';
import { BasePage, Helmet, FourOhFourErrorPage, SurveyTheme } from '@sm/webassets';
import { t } from '@sm/intl';

import SurveyTitle from '~app/components/Survey/SurveyTitle';
import Layout from '~app/components/Survey/Layout';

import { getSurveyIdFromCollector, getSurveyDetails } from './SurveyTaking.graphql';

const COPY = {
  META_DESCRIPTION: {
    id: 'SurveyTaking.metaDescription',
    defaultMessage:
      "Web survey powered by SurveyMonkey.com. Create your own online survey now with SurveyMonkey's expert certified FREE templates.",
  },
};

const SurveyTaking = () => {
  // TODO: get url from StaticContext, convert slug to collectorId.
  const collectorId = '55804393';

  const {
    loading: loadingCollector,
    error: errorCollector,
    data: collectorData,
  } = useQuery(getSurveyIdFromCollector, {
    variables: {
      collectorId,
    },
  });

  if (errorCollector) {
    throw errorCollector;
  }

  const {
    loading: loadingSurvey,
    error: errorSurvey,
    data: surveyData,
  } = useQuery(getSurveyDetails, {
    skip: !collectorData || loadingCollector,
    variables: {
      surveyId: collectorData?.collector?.surveyId,
    },
  });

  if (errorSurvey) {
    throw errorSurvey;
  }

  if (!loadingSurvey && surveyData.survey === null) {
    return <FourOhFourErrorPage />;
  }

  if (surveyData) {
    const surveyId = collectorData?.collector?.surveyId;
    const surveyTitle = surveyData?.survey?.title;
    const questions = surveyData?.survey?.questionsQM?.items ?? [];
    const langCode = surveyData?.survey?.language?.code;
    const isRTL = ['ar', 'he', 'fa'].indexOf(langCode) > -1;

    // TODO: use react-jss for theme in Header/Footer components when replacing
    return (
      <BasePage
        actionFlow="SurveyTaking"
        pageId="SurveyTaking"
        legacyWeb="respweb"
        includeHeader={false}
        includeFooter={false}
      >
        <Helmet htmlAttributes={{ lang: langCode }}>
          <title>{surveyTitle} Survey</title>
          <meta name="description" content={t(COPY.META_DESCRIPTION)} />
          <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=yes" />
          <meta httpEquiv="content-language" content={langCode} />
        </Helmet>
        <SurveyTheme surveyId={surveyId} targetEndPoint="surveyTaking">
          <Layout isRTL={isRTL}>
            <div> HEADER PLACEHOLDER </div>
            <SurveyTitle title={surveyTitle} />
            {questions.map(q => {
              const {
                id,
                position: { inPage },
                heading: {
                  default: { text },
                },
              } = q;
              return (
                <div key={id}>
                  <h3> {`Q: ${inPage} `}</h3>
                  <h3>{text}</h3>
                </div>
              );
            })}
            <div> FOOTER PLACEHOLDER </div>
          </Layout>
        </SurveyTheme>
      </BasePage>
    );
  }
  return null;
};

export default SurveyTaking;
